import autoServiceValidation from "./autoServiceValidation";

export default autoServiceValidation;
